import { useState, useEffect } from "react";

const RECENT_EMOJIS_KEY = "recent_emojis";
const MAX_RECENT_EMOJIS = 6;

export function useRecentEmojis() {
  const [recentEmojis, setRecentEmojis] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem(RECENT_EMOJIS_KEY);
    if (stored) {
      setRecentEmojis(JSON.parse(stored));
    }
  }, []);

  const addRecentEmoji = (emoji) => {
    const newRecentEmojis = [
      emoji,
      ...recentEmojis.filter((e) => e !== emoji),
    ].slice(0, MAX_RECENT_EMOJIS);

    setRecentEmojis(newRecentEmojis);
    localStorage.setItem(RECENT_EMOJIS_KEY, JSON.stringify(newRecentEmojis));
  };

  return {
    recentEmojis,
    addRecentEmoji,
  };
}
